// extracted by mini-css-extract-plugin
module.exports = {"image":"womanizer_image__YPW4l","womanizerArticle":"womanizer_womanizerArticle__vRDLm"};